import { GeoDataObj, Status } from '@/services/types/api.types'
import { createSlice } from '@reduxjs/toolkit'

const initialState: {
  isLoading: boolean
  filterPayload: { fields: unknown[]; conditions: unknown[] }
  eventsTableData: unknown[]
  trafficData: unknown
  networkData: {
    networkData: GeoDataObj[]
    mapStatusData: Status | null
  }
  networkStatus: Status
  mergedGeoData: []
} = {
  isLoading: true,
  filterPayload: { fields: [], conditions: [] },
  eventsTableData: [],
  trafficData: {},
  networkData: {
    mapStatusData: null,
    networkData: [],
  },
  networkStatus: {
    sitesStatus: {
      '': {
        id: '',
        status: '',
        siteName: ',',
      },
    },
    totalData: {
      totalSites: 0,
      onlineSites: 0,
      degradedSites: 0,
    },
    orderStatus: '',
    dueDate: '',
    trackingNumber: '',
  },
  mergedGeoData: [],
}

const eventListSlice = createSlice({
  name: 'eventList',
  initialState,
  reducers: {
    setFilterPayload: (state, action) => {
      state.filterPayload = action.payload
    },

    isLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setEventsTableData: (state, action) => {
      state.eventsTableData = action.payload
    },
    setNetworkData: (state, action) => {
      state.networkData = action.payload
    },
    setTrafficData: (state, action) => {
      state.networkData = action.payload
    },
    setMergedGeoData: (state, action) => {
      state.mergedGeoData = action.payload
    },
    setNetworkStatus: (state, action) => {
      state.networkStatus = action.payload
    },
  },
})

export const {
  isLoading,
  setEventsTableData,
  setNetworkData,
  setNetworkStatus,
  setTrafficData,
  setMergedGeoData,
  setFilterPayload,
} = eventListSlice.actions
export default eventListSlice.reducer
